import * as React from 'react';
import { Editor } from 'primereact/editor';
import { AdminMedicineModel } from "../../models/medicine";
import Translate from '../../common/functions/translate';

interface IProps {
  handleChange: any,
  medicine: AdminMedicineModel,
  getValue: any,
  selectedLangId: number
}

interface IState {
}

class MedicineTabPregnancy extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
    };
  }

  public render() {

    const { pregnancyAndBreastfeeding } = this.props.medicine;

    return (
      <div className="p-grid p-fluid p-md-12">
        <div className="p-col-12 p-md-12">
          <label>{Translate("Pregnancy and Breastfeeding")}:</label>
          <Editor
            style={{ width: '100%', height: '150px' }}
            onTextChange={(e) => { this.props.handleChange('pregnancyContent', e.htmlValue) }}
            value={this.props.getValue('pregnancyContent')}
          />
        </div>
        {/* <div className="p-col-12 p-md-12">
          <label>{Translate("Breastfeeding")}:</label>
          <Editor
            style={{ width: '100%', height: '150px' }}
            onTextChange={(e) => { this.props.handleChange('breastfeedingContent', e.htmlValue) }}
            value={this.props.getValue('breastfeedingContent')}
          />
        </div> */}
      </div>
    )
  }
}

export default MedicineTabPregnancy;